
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 182 160"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M0 0h182v160H0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M20 18h77v10H20z"}}),_c('path',{attrs:{"d":"M21 52h66.43v11H21z"}}),_c('path',{attrs:{"d":"M20 42h35v6H20z"}}),_c('path',{attrs:{"d":"M95 52h66.43v11H95z"}}),_c('path',{attrs:{"d":"M94 42h35v6H94z"}}),_c('circle',{attrs:{"cx":"24.5","cy":"107.5","r":"3.5"}}),_c('path',{attrs:{"d":"M34.04 104.53h35V110h-35zM73.04 104.53h64.17V110H73.04z"}}),_c('circle',{attrs:{"cx":"24.5","cy":"120.83","r":"3.5"}}),_c('path',{attrs:{"d":"M34.04 117.86h24.95v5.47H34.04zM63.04 117.86h41.79v5.47H63.04z"}}),_c('circle',{attrs:{"cx":"24.5","cy":"134.17","r":"3.5"}}),_c('path',{attrs:{"d":"M34.04 131.2h35v5.47h-35zM73.04 131.2h24v5.47h-24zM101.04 131.2h42.64v5.47h-42.64z"}}),_c('circle',{attrs:{"cx":"24.5","cy":"147.5","r":"3.5"}}),_c('path',{attrs:{"d":"M34.04 144.53h38.6V150h-38.6zM76.04 144.53h25.17V150H76.04z"}}),_c('circle',{attrs:{"cx":"24.5","cy":"107.5","r":"1.5"}}),_c('path',{attrs:{"d":"M95 79h7v7h-7zM21 82h66.43v11H21z"}}),_c('path',{attrs:{"d":"M20 72h35v6H20zM107 79h19v6h-19zM130 79h32.92v6H130z"}}),_c('path',{attrs:{"d":"m83.7 86.25-3.43 3.43-3.42-3.43"}})])
          )
        }
      }
    